// extracted by mini-css-extract-plugin
module.exports = {"style_a":"MainModal_style_a__2RFFm","style_a1":"MainModal_style_a1__2J9jJ","mouse_hover":"MainModal_mouse_hover__2rdYt"};